import React from 'react'
import styled, { css } from 'styled-components'
import {
  calculateResponsiveSize,
  mediaMax,
  textBoxTrim,
  themeColor
} from '@dboxdev/ui-components'
import { Link } from 'gatsby'

const pill = themeColor('textColor')
const label = themeColor('backgroundColor')

const filled = css`
  border-color: var(--button-color, ${pill});
  background: var(--button-color, ${pill});
  &&,
  &&:hover {
    color: var(--button-contrast, ${label});
  }
`

export const ButtonBase = styled((props) => <Link {...props} />)`
  ${textBoxTrim};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $width }) => calculateResponsiveSize($width)};
  height: ${({ $height }) => calculateResponsiveSize($height)};
  padding: ${calculateResponsiveSize(10)} ${calculateResponsiveSize(20)};
  font-family: var(--font-secondary);
  font-weight: 100;
  font-size: ${({ $fontSize }) => calculateResponsiveSize($fontSize)};
  line-height: 1.19;
  white-space: nowrap;
  border: 1px solid var(--button-color, ${pill});
  border-radius: ${calculateResponsiveSize(40)};
  background: none;
  cursor: pointer;
  transition: background 0.4s, color 0.4s, border-color 0.4s, opacity 0.4s;
  &&,
  &&:hover {
    color: var(--button-color, ${pill});
  }
  &:hover {
    ${filled};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  ${({ $variant }) => $variant === 'filled' && filled};
  ${({ $mobile }) => $mobile && css`
    ${mediaMax('mobile')} {
      width: ${calculateResponsiveSize($mobile.width)};
      height: ${calculateResponsiveSize($mobile.height)};
      padding: ${calculateResponsiveSize(6)} ${calculateResponsiveSize(15)};
      font-size: ${calculateResponsiveSize($mobile.fontSize)};
    }
  `};
`
